import React from "react";
import { useParams } from "react-router-dom";
import ServiceOperationMainComponent from "views/Components/ServicesOperationComponent/Main/ServiceOperationMainComponent";

const ServiceOperationComponentPage = ({ page }) => {
  const { id } = useParams();

  return (
    <div style={mainDiv}>
      <ServiceOperationMainComponent page={page} id={id} />
    </div>
  );
};

export default ServiceOperationComponentPage;

const mainDiv = {
  height: "100%",
  border: "0px solid black",
};
